import { TOUR_V2_DEFAULT_OCCUPANCIES } from 'constants/tours'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { max, min } from 'lib/arrayUtils'
import createSelector from 'lib/createSelector'
import { generateRoomOccupants, sumUpOccupancies } from 'lib/occupancyUtils'

export const getOccupancies = createSelector(
  (offerPageState: OfferPageState) => offerPageState.rooms,
  (rooms): OfferPageState['rooms'] => rooms ?? TOUR_V2_DEFAULT_OCCUPANCIES.map(generateRoomOccupants),
)

export const getRoomSizes = createSelector(
  getOccupancies,
  (occupancies): Set<number> => occupancies.reduce<Set<number>>(
    (roomSizes, occupants) => {
      roomSizes.add(sumUpOccupancies([occupants], new Set(['adults', 'children'])))

      return roomSizes
    },
    new Set(),
  ),
)

export const getHasChildExceedingAgeRange = createSelector(
  (offerPageState: OfferPageState) => offerPageState.selectedTourV2OfferVariation,
  (offerPageState: OfferPageState) => getOccupancies(offerPageState),
  (
    selectedVariation,
    occupancies,
  ): {
    hasChildExceedingMaxAge: boolean,
    hasChildExceedingMinAge: boolean,
  } => {
    const childTravellerAges = occupancies.flatMap(occupant => occupant.childrenAge ?? [])

    return {
      hasChildExceedingMaxAge: max(childTravellerAges) >= selectedVariation?.maxChildPriceAge,
      hasChildExceedingMinAge: min(childTravellerAges) < selectedVariation?.minChildPriceAge,
    }
  },
)
